import { Card, Space } from "@mantine/core";
import TableEmbaixadores from "@/modules/relatorio/components/table-embaixadores";

const EmbaixadoresTab = () => {
  return (
    <Card>
      <TableEmbaixadores tipo="pessoas" />
      <Space h={"xl"} />
      <TableEmbaixadores tipo="entidades" />
    </Card>
  );
};

export default EmbaixadoresTab;
